export default __webpack_public_path__ + "static/media/someone_probably_fucking_dies.60f7fdb2.mp3";